import { createApiCall } from 'services'
import { getErrorMessage } from 'utils'


import type {
  GetCertificatesPayload,
  GetCertificatesResponse,
  CreateCertificatePayload,
  CreateCertificateResponse,
  GetCertificateByIdPayload,
  GetCertificateByIdResponse,
  TransferCertificatePayload,
  TransferCertificateResponse,
  CancelTransferCertificatePayload,
  CancelTransferCertificateResponse,
  GetCertificateProvenancePayload,
  GetCertificateProvenanceResponse,
  GetCertificateScansPayload,
  GetCertificateScansResponse,
  EditCertificatePayload,
  EditCertificateResponse,
} from './types'
import type { ActionCallback } from '../model'

import { call, put, fork, takeLatest } from 'redux-saga/effects'

import { CertificatesActions } from './types'





export function* getCertificatesSaga(): Generator {
  yield takeLatest(CertificatesActions.GET_CERTIFICATES, function* (action: ActionCallback<GetCertificatesPayload>) {
    try {
      const { payload, callback } = action

      const response: GetCertificatesResponse = yield call(createApiCall, {
        url: '/certificates/admin',
        params: payload,
      })

      const { data, status } = response

      if (status === 200) {
        yield put({
          type: CertificatesActions.SET_CERTIFICATES,
          payload: data,
        })
      }

      callback && callback()
    } catch (e) {
      console.error(e)
    }
  })
}

export function* getCertificateByIdSaga(): Generator {
  yield takeLatest(CertificatesActions.GET_CERTIFICATE, function* (action: ActionCallback<GetCertificateByIdPayload>) {
    try {
      const { payload, callback } = action
      const { certificateId } = payload

      const response: GetCertificateByIdResponse = yield call(createApiCall, {
        url: `/certificates/public/${certificateId}`,
      })

      const { data, status } = response

      if (status === 200) {
        yield put({
          type: CertificatesActions.SET_CERTIFICATE,
          payload: data,
        })
      }

      callback && callback({ success: true, content: data })
    } catch (e) {
      console.error(e)
      action.callback && action.callback({ success: false, content: getErrorMessage(e) })
    }
  })
}

export function* createCertificateSaga(): Generator {
  yield takeLatest(
    CertificatesActions.CREATE_CERTIFICATE,
    function* (action: ActionCallback<CreateCertificatePayload>) {
      const { payload, callback } = action
      try {
        const response: CreateCertificateResponse = yield call(createApiCall, {
          method: 'POST',
          url: '/certificates/admin',
          data: payload,
        })

        const { data, status } = response

        if (callback) {
          callback({
            success: true,
            content: data,
          })
        }
      } catch (e) {
        console.warn(e)
        if (callback) {
          callback({
            success: false,
            content: getErrorMessage(e),
          })
        }
      }
    }
  )
}

export function* transferCertificateSaga(): Generator {
  yield takeLatest(
    CertificatesActions.TRANSFER_CERTIFICATE,
    function* (action: ActionCallback<TransferCertificatePayload>) {
      const { payload, callback } = action
      const { certificateId, ...rest } = payload

      try {
        const response: TransferCertificateResponse = yield call(createApiCall, {
          method: 'POST',
          url: `/transfer/admin/init/${certificateId}`,
          data: rest,
        })

        const { data, status } = response

        if (callback) {
          callback({
            success: true,
            content: data,
          })
        }
      } catch (e) {
        console.warn(e)
        if (callback) {
          callback({
            success: false,
            content: getErrorMessage(e),
          })
        }
      }
    }
  )
}

export function* cancelTransferCertificateSaga(): Generator {
  yield takeLatest(
    CertificatesActions.CANCEL_TRANSFER_CERTIFICATE,
    function* (action: ActionCallback<CancelTransferCertificatePayload>) {
      const { payload, callback } = action
      const { certificateId } = payload

      try {
        const response: CancelTransferCertificateResponse = yield call(createApiCall, {
          method: 'POST',
          url: `/transfer/admin/cancel/${certificateId}`,
        })

        const { data, status } = response

        if (callback) {
          callback({
            success: true,
            content: data,
          })
        }
      } catch (e) {
        console.warn(e)
        if (callback) {
          callback({
            success: false,
            content: getErrorMessage(e),
          })
        }
      }
    }
  )
}

export function* getCertificateProvenanceSaga(): Generator {
  yield takeLatest(
    CertificatesActions.GET_CERTIFICATE_PROVENANCE,
    function* (action: ActionCallback<GetCertificateProvenancePayload>) {
      try {
        const { payload, callback } = action
        const { certificateId, ...rest } = payload

        const response: GetCertificateProvenanceResponse = yield call(createApiCall, {
          url: `/certificates/admin/provenance/${certificateId}`,
          params: rest,
        })

        const { data, status } = response

        if (status === 200) {
          yield put({
            type: CertificatesActions.SET_CERTIFICATE_PROVENANCE,
            payload: data,
          })
        }

        callback && callback({ success: true, content: data })
      } catch (e) {
        console.error(e)
        action.callback && action.callback({ success: false, content: getErrorMessage(e) })
      }
    }
  )
}

export function* getCertificateScansSaga(): Generator {
  yield takeLatest(
    CertificatesActions.GET_CERTIFICATE_SCANS,
    function* (action: ActionCallback<GetCertificateScansPayload>) {
      try {
        const { payload, callback } = action
        const { certificateId, ...rest } = payload

        const response: GetCertificateScansResponse = yield call(createApiCall, {
          url: `/scan-log/public/${certificateId}`,
          params: rest,
        })

        const { data, status } = response

        if (status === 200) {
          yield put({
            type: CertificatesActions.SET_CERTIFICATE_SCANS,
            payload: data,
          })
        }

        callback && callback({ success: true, content: data })
      } catch (e) {
        console.error(e)
        action.callback && action.callback({ success: false, content: getErrorMessage(e) })
      }
    }
  )
}

export function* editCertificateSaga(): Generator {
  yield takeLatest(CertificatesActions.EDIT_CERTIFICATE, function* (action: ActionCallback<EditCertificatePayload>) {
    const { payload, callback } = action
    const { certificateId, ...rest } = payload
    try {
      const response: EditCertificateResponse = yield call(createApiCall, {
        method: 'POST',
        url: `/certificates/admin/${certificateId}`,
        data: rest,
      })

      const { data, status } = response

      if (callback) {
        callback({
          success: true,
          content: data,
        })
      }
    } catch (e) {
      console.warn(e)
      if (callback) {
        callback({
          success: false,
          content: getErrorMessage(e),
        })
      }
    }
  })
}

export default [
  fork(getCertificatesSaga),
  fork(createCertificateSaga),
  fork(getCertificateByIdSaga),
  fork(getCertificateProvenanceSaga),
  fork(getCertificateScansSaga),
  fork(transferCertificateSaga),
  fork(cancelTransferCertificateSaga),
  fork(editCertificateSaga),
]
